module.exports = __webpack_public_path__ + "static/abonnement-1-f068b1ed3774d6ca040456edd9305117.svg";